/**
 * @generated SignedSource<<56c15ee8970a110273067188f5467912>>
 * @relayHash 4ec8a5bf6477eca8e9e3753e36ef3d0c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4ec8a5bf6477eca8e9e3753e36ef3d0c

import type { ConcreteRequest } from 'relay-runtime';
export type IssueEventConfidenceLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type CreateIssueInput = {
  agentAssignment?: AgentAssignmentInput | null | undefined;
  assigneeIds?: ReadonlyArray<string> | null | undefined;
  body?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  copilotAssignment?: CopilotAssignmentInput | null | undefined;
  isDuplicated?: boolean | null | undefined;
  issueFields?: ReadonlyArray<IssueFieldCreateOrUpdateInput> | null | undefined;
  issueTemplate?: string | null | undefined;
  issueTypeId?: string | null | undefined;
  labelIds?: ReadonlyArray<string> | null | undefined;
  milestoneId?: string | null | undefined;
  parentIssueId?: string | null | undefined;
  position?: ReadonlyArray<number> | null | undefined;
  projectIds?: ReadonlyArray<string> | null | undefined;
  projectV2Ids?: ReadonlyArray<string> | null | undefined;
  repositoryId: string;
  title: string;
};
export type AgentAssignmentInput = {
  baseRef?: string | null | undefined;
  customAgent?: string | null | undefined;
  customInstructions?: string | null | undefined;
  model?: string | null | undefined;
  targetRepositoryId?: string | null | undefined;
};
export type CopilotAssignmentInput = {
  baseRef?: string | null | undefined;
  customAgent?: string | null | undefined;
  customInstructions?: string | null | undefined;
  model?: string | null | undefined;
  targetRepositoryId?: string | null | undefined;
};
export type IssueFieldCreateOrUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  dateValue?: string | null | undefined;
  delete?: boolean | null | undefined;
  fieldId: string;
  multiSelectOptionIds?: ReadonlyArray<string> | null | undefined;
  numberValue?: number | null | undefined;
  rationale?: string | null | undefined;
  singleSelectOptionId?: string | null | undefined;
  suggest?: boolean | null | undefined;
  textValue?: string | null | undefined;
};
export type createIssueFromChecklistItemMutation$variables = {
  input: CreateIssueInput;
};
export type createIssueFromChecklistItemMutation$data = {
  readonly createIssue: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly issue: {
      readonly parent: {
        readonly body: string;
        readonly bodyHTML: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type createIssueFromChecklistItemMutation$rawResponse = {
  readonly createIssue: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }>;
    readonly issue: {
      readonly id: string;
      readonly parent: {
        readonly body: string;
        readonly bodyHTML: string;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type createIssueFromChecklistItemMutation = {
  rawResponse: createIssueFromChecklistItemMutation$rawResponse;
  response: createIssueFromChecklistItemMutation$data;
  variables: createIssueFromChecklistItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createIssueFromChecklistItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateIssuePayload",
        "kind": "LinkedField",
        "name": "createIssue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "createIssueFromChecklistItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateIssuePayload",
        "kind": "LinkedField",
        "name": "createIssue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4ec8a5bf6477eca8e9e3753e36ef3d0c",
    "metadata": {},
    "name": "createIssueFromChecklistItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7c510d2270ce1215f656d34e670c064f";

export default node;
